// extracted by mini-css-extract-plugin
export var cardSelected = "_iy-2";
export var image = "_iy-1";
export var table = "_iy-0";